import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const XXX = new Vuex.Store({
    state: {
        loggedIn: false,
        userToken: ""
    },

    mutations: {
        setLoggedIn(state, flag) {
            state.loggedIn = flag;
        }
    },

    actions: {
        setLoggedIn({ commit }, flag) {
            commit("setLoggedIn", flag);
        }
    }
});

export default XXX;
window.SSS = XXX;
